var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcMessageFill = function SvgIcMessageFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 12.017C1 6.222 5.631 1 12.022 1 18.27 1 23 6.123 23 11.984 23 18.78 17.456 23 12 23c-1.804 0-3.806-.485-5.412-1.432-.561-.342-1.034-.595-1.639-.397l-2.222.661c-.561.177-1.067-.264-.902-.859l.737-2.468c.121-.341.099-.705-.077-.991C1.539 15.774 1 13.867 1 12.017m9.57 0c0 .782.627 1.41 1.408 1.42.781 0 1.408-.638 1.408-1.41 0-.782-.627-1.41-1.408-1.41a1.4 1.4 0 0 0-1.408 1.4m5.071.01c0 .772.627 1.41 1.408 1.41s1.408-.638 1.408-1.41c0-.782-.627-1.41-1.408-1.41s-1.408.628-1.408 1.41m-8.734 1.41c-.77 0-1.408-.638-1.408-1.41 0-.782.627-1.41 1.408-1.41s1.408.628 1.408 1.41c0 .772-.627 1.4-1.408 1.41",
    clipRule: "evenodd"
  })));
};
export default SvgIcMessageFill;